import {
  ESSENTIALS_MENU_ITEM,
  ProductLicenseKeysEnum,
  SUBJECT_AREA_ITEMS,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import { PopoutMenuSection } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutMenuSection";
import { PopoutSectionItem } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutSectionItem";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import useGetUserExperimentSegment from "@/features/useGetUserExperimentSegment";
import useUserFeaturesQuery from "@/users/v3/useUserFeaturesQuery";

const SubjectsMenuPopoutSection = () => {
  const { data: user } = useUser();
  const {
    activeELALicense,
    activeSSLicense,
    activeScienceLicense,
    activeEssentialsLicense,
    isStudent,
  } = getUserProperties(user, { shouldUseNewUserApi: false });

  const { data: features } = useUserFeaturesQuery();

  const activeStemLicense = features?.includes("has_stem_license");

  const [showLockIconsExperiment] =
    useGetUserExperimentSegment("show_lock_icons");

  const showLicenseItemWithLock = showLockIconsExperiment === "on";
  const licensesMap = {
    [ProductLicenseKeysEnum.SS]: activeSSLicense,
    [ProductLicenseKeysEnum.ELA]: activeELALicense,
    [ProductLicenseKeysEnum.SCI]: activeScienceLicense,
    [ProductLicenseKeysEnum.STEM]: activeStemLicense,
  };

  return (
    <PopoutMenuSection title="Subjects" width="15.625rem">
      {activeEssentialsLicense && (
        <PopoutSectionItem
          href={ESSENTIALS_MENU_ITEM.href}
          title={ESSENTIALS_MENU_ITEM.title}
          SvgComponent={ESSENTIALS_MENU_ITEM.SvgComponent}
          locked={false}
          dataQASelector={ESSENTIALS_MENU_ITEM.dataQASelector}
        />
      )}
      {SUBJECT_AREA_ITEMS.filter(({ license }) => {
        const isStem = license === ProductLicenseKeysEnum.STEM;
        const isScience = license === ProductLicenseKeysEnum.SCI;

        if (isStem) {
          return activeStemLicense;
        }

        if (isScience) {
          return (
            (activeScienceLicense || (showLicenseItemWithLock && !isStudent)) &&
            !activeStemLicense
          );
        }

        // All other subjects
        return licensesMap[license] || (showLicenseItemWithLock && !isStudent);
      }).map(
        ({ title, href, SvgComponent, license, dataQASelector }, index) => (
          <PopoutSectionItem
            key={index}
            href={href}
            title={title}
            SvgComponent={
              license === ProductLicenseKeysEnum.STEM
                ? (props: any) => <SvgComponent {...props} size={24} />
                : SvgComponent
            }
            locked={!licensesMap[license]}
            dataQASelector={dataQASelector}
          />
        ),
      )}
    </PopoutMenuSection>
  );
};

SubjectsMenuPopoutSection.displayName = "SubjectsMenuPopoutSection";
export { SubjectsMenuPopoutSection };
